import { FormattedMessage } from 'react-intl';
import { Button, Col, Row } from 'antd';

import { cssVariables } from '../../styles/cssVariables';
import { useDialogToolbarStyles } from '../../styles/dialogToolbar.styles';
import { pxToNumber } from '../../utils/cssUtils';
import { GraphQLMutatingIconButton } from '../../components/data/asyncActionElements';
import BackButton from '../../components/buttons/BackButton';
import { useInvoiceStyles } from './invoice.styles';

export default function InvoiceContainer({
  children,
  onClose,
  titleCount,
  titleId,
  handleBack,
  actionButtons = [],
}) {
  const { styles } = useInvoiceStyles();
  const { styles: toolbarStyles } = useDialogToolbarStyles();
  return (
    <div className={styles.container}>
      {handleBack && <BackButton onClick={handleBack} />}
      <div className={styles.toolbar}>
        <div className={toolbarStyles.toolbarTitle}>
          <FormattedMessage id={titleId} />
          {titleCount && <span className={styles.count}> ({titleCount})</span>}
        </div>
        <Row gutter={pxToNumber(cssVariables.spaceNorm)}>
          {onClose && (
            <Col>
              <Button size="large" onClick={onClose} className="width-100">
                <FormattedMessage id="buttons.cancel" />
              </Button>
            </Col>
          )}
          {actionButtons.map(({ labelId, icon, mutationProps }) => (
            <Col key={labelId}>
              <GraphQLMutatingIconButton
                className={styles.printButton}
                labelId={labelId}
                icon={icon}
                {...mutationProps}
              />
            </Col>
          ))}
        </Row>
      </div>
      {children}
    </div>
  );
}
